import { render, staticRenderFns } from "./edit_single_group.vue?vue&type=template&id=19ed01bb&scoped=true&"
import script from "./edit_single_group.vue?vue&type=script&lang=ts&"
export * from "./edit_single_group.vue?vue&type=script&lang=ts&"
import style0 from "./edit_single_group.vue?vue&type=style&index=0&id=19ed01bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed01bb",
  null
  
)

export default component.exports